import { Component, OnInit } from '@angular/core';
import { InsuranceService } from '../Services/insurance-service.service';
import { Router, RouterLink } from '@angular/router';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { DxDataGridModule, DxPopupModule } from 'devextreme-angular';
import { DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxoScrollingModule, DxoPagerModule, DxiColumnModule, DxoSearchPanelModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { NgIf } from '@angular/common';


@Component({
    selector: 'app-zeus-booked-policies',
    templateUrl: './zeus-booked-policies.component.html',
    styleUrls: ['./zeus-booked-policies.component.css'],
    imports: [NavMenuComponent, DxDataGridModule, DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxoScrollingModule, DxoPagerModule, DxiColumnModule, DxoSearchPanelModule, DxTemplateModule, DxPopupModule, NgIf]
})
export class ZeusBookedPoliciesComponent implements OnInit {

  constructor(private insurance: InsuranceService, public router: Router) { }
  allpolicies: any[] = []
  zeusPolicies: any[] = [];

  ngOnInit() {
    this.getZeusInsurance()
  }
  routeToIssue() {
    this.router.navigateByUrl("insurance-issuance");
  }
  routeToCancel() {
    this.router.navigateByUrl("cancel-insurance-policy");
  }
  RouteToUnited()
  {
    this.router.navigateByUrl("united-travel-insurance");
  }
  RouteToZeus(){
    this.router.navigateByUrl("insurance-issuance")
  }

  getZeusInsurance() {
    this.insurance.getAllPolicies(4).subscribe((res) => {
      console.log(res);

      const mappedPolicies = res.map((item: any) => {
        return {
          ...item.purchaseInformation,        // Flattened purchase info
          confirmedPassengers: item.confirmedPassengers // Add passengers info
        };
      });

      // Now filter based on PolicyType
      this.zeusPolicies = mappedPolicies;
      console.log(this.zeusPolicies);
    });
  }
  popupVisible = false;
  selectedPassengers: any[] = [];

  showPassengersPopup(passengers: any[]) {
    if (!passengers || passengers.length === 0) {
      console.log("No confirmed passengers found.");
      this.selectedPassengers = [];
    } else {
      console.log("Passengers:", passengers);
      this.selectedPassengers = passengers;
    }
    this.popupVisible = true;
  }


}
